import React from "react";
import InsideHeader from "../../../components/InsideHeader";
import { useSelector } from "react-redux";
import { Descriptions } from "antd";
import { cashConverter, dateForHumans, numberWithCommas } from "../../../utils";

function StoreRequestDetails() {
  const { folderObj } = useSelector((state) => state.folder);
  const items = [ 
    {
      key: "1",
      label: "Description",
      children: folderObj?.srDescription,
    },

    {
      key: "2",
      label: "Quantity",
      children: <div>{numberWithCommas(folderObj?.srQuantity)}</div>,
    },
    {
      key: "3",
      label: "Unit Cost",
      children: <div>{cashConverter(folderObj?.srUnitCost)}</div>,
    },
    {
      key: "9",
      label: "Total Cost",
      children: <div>{cashConverter(folderObj?.srTotalCost)}</div>,
    },
    {
      key: "4",
      label: "Serial Number",
      children: folderObj?.srNo,
    },

    {
      key: "5",
      label: "Created Date",
      children: <div>{dateForHumans(folderObj?.srCreatedDate)}</div>,
    },
    {
      key: "6",
      label: "Status",
      children: folderObj?.srStatus,
    },
  ];
  return (
    <div className="w-full h-full overflow-y-scroll">
      <InsideHeader
        title="Store Request information"
        subtitle="Manage Store Request within your institution"
        back={true}
        title1="Store Request"
        title2="Store Request details"
      />

      <div className="bg-white rounded-[10px] mt-[1.25rem] h-full">
        <div className="flex flex-col w-full lg:px-10 px-3 ">
          <div className="mt-[1.25rem]">
            <Descriptions
              column={{ xs: 1, sm: 2 }}
              colon={false}
              title="Store Request Information"
              items={items}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default StoreRequestDetails;
